var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5InboxArrowWithBackground = function SvgAv5InboxArrowWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "icon-with-background"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "av5_inbox_arrow-with-background_svg__icon-background",
    r: 9,
    cx: 9,
    cy: 9,
    fill: "#ECF0FD",
    "data-no-stroke": "true"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "av5_inbox_arrow-with-background_svg__inner-vectors",
    stroke: "#8399C6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.485 8.72H4",
    "data-no-fill": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.465 4.281 13 8.746 8.531 12.78",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  }))));
};
export { SvgAv5InboxArrowWithBackground as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgdmlld0JveD0iMCAwIDE4IDE4IgogICAgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgIGRhdGEtdmFyaWFudD0iaWNvbi13aXRoLWJhY2tncm91bmQiCj4KICAgIDxjaXJjbGUgY2xhc3M9Imljb24tYmFja2dyb3VuZCIgcj0iOSIgY3g9IjkiIGN5PSI5IiBmaWxsPSIjRUNGMEZEIiBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIvPgogICAgPGcgY2xhc3M9ImlubmVyLXZlY3RvcnMiPgogICAgICAgIDxwYXRoIGQ9Ik0xMi40ODUzIDguNzE5Mkg0LjAwMDA0IiBzdHJva2U9IiM4Mzk5QzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgICAgIDxwYXRoIGQ9Ik04LjQ2NDg0IDQuMjgxMjVMMTMgOC43NDU4M0w4LjUzMTQ5IDEyLjc4MSIgc3Ryb2tlPSIjODM5OUM2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgICAgICAgICAgIGRhdGEtbm8tZmlsbD0idHJ1ZSIvPgogICAgPC9nPgo8L3N2Zz4K";